import { createContext, useState, useContext, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { useUserData } from "./userContext";
import stepLogClass from "src/data/stepLog/stepLogClass";

const StepLogContext = createContext();

export const StepLogProvider = ({ children, keikkaId }) => {
  const [stepLog, setStepLog] = useState(new stepLogClass(keikkaId));
  const { token, socket } = useUserData();
  const [isStepLogLoaded, setIsStepLogLoaded] = useState(false);

  const resetLoadingState = () => {
    setIsLoaded({ ...isLoaded, init: false });
  };
  const [isLoaded, setIsLoaded] = useState({
    init: false,
  });
  const isLoadedPercent = {
    percent: Math.round(
      (Object.values(isLoaded).filter((v) => v).length / Object.keys(isLoaded).length) * 100
    ),
    count: Object.keys(isLoaded).length,
  };

  useEffect(() => {
    if (!keikkaId || !token) return;
    const _asynk = async () => {
      await reloadStepLog();
      setIsStepLogLoaded(true);
    };
    _asynk();
  }, [keikkaId, token]);

  const doSetStepLog = useCallback(
    (stepLog) => {
      setStepLog(stepLog);
    },
    [stepLog, stepLog?.uniqueHash]
  );

  const reloadStepLog = async () => {
    setIsLoaded({ ...isLoaded, init: false });
    setIsStepLogLoaded(false);
    const stepLog = new stepLogClass(keikkaId);
    await stepLog.init(token, socket);
    doSetStepLog(stepLog);
    setIsStepLogLoaded(true);
    setIsLoaded({ ...isLoaded, init: true });
  };

  return (
    <StepLogContext.Provider
      value={{
        stepLog,
        doSetStepLog,
        reloadStepLog,
        isStepLogLoaded,
        isLoadedPercent,
        resetLoadingState,
      }}>
      {children}
    </StepLogContext.Provider>
  );
};

export const useStepLogData = () => useContext(StepLogContext);

StepLogProvider.propTypes = {
  children: PropTypes.node.isRequired,
  keikkaId: PropTypes.number,
};
